export default __webpack_public_path__ + "static/media/vito.05a1dba0.png";